import preferences from "@coworker/enums/profilePreferences";
import { useUserPreferenceStoreFilterValues } from "@coworker/apprestructured/src/shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { usePeriodFilter } from "./usePeriodFilter";
import { useLocationFilter } from "./useLocationFilter";
import { useQuestionsWithTasksOnlyFilter } from "./useQuestionsWithTasksOnlyFilter";

export function useMfaqFilters({
  hideQuestionsWithTasksOnly,
}: {
  hideQuestionsWithTasksOnly: boolean;
}) {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.MFAQ_FILTERS
  );

  const useMfaqDataFilters = (values: FilterValue[]) => [
    usePeriodFilter(values),
    useLocationFilter(),
    useQuestionsWithTasksOnlyFilter(values, hideQuestionsWithTasksOnly),
  ];

  return {
    useFiltersFactory: useMfaqDataFilters,
    filterValues,
    setFilterValues,
  };
}
